import React from 'react';
import { Navbar } from './components/Navbar/Navbar';
import { HeroSection } from './components/HeroSection/HeroSection';
import { Footer } from './components/Footer/Footer';
import './HomePage.css';

export function HomePage() {
  return (
    <div className="home-page">
      <Navbar />
      <main>
        <HeroSection />
      </main>
      <Footer />
    </div>
  );
}

export default HomePage;

